import { render, staticRenderFns } from "./ChannelReach.vue?vue&type=template&id=0549ce0a&scoped=true&"
import script from "./ChannelReach.vue?vue&type=script&lang=js&"
export * from "./ChannelReach.vue?vue&type=script&lang=js&"
import style0 from "./ChannelReach.vue?vue&type=style&index=0&id=0549ce0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0549ce0a",
  null
  
)

export default component.exports